import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

export const useRightInquiryTextButton = (link?: string, clickEvent?: string) => {
  const { openChannelTalk } = useChannelTalk();
  const { sendClickEvent } = useUserEventLogger();

  return {
    label: '문의하기',
    onClick: () => {
      if (clickEvent) {
        sendClickEvent(clickEvent);
      }

      openChannelTalk(link || SUPPORT_BOT_LINK.default);
    }
  };
};
